<script>
export default class UploadAdapter {
    constructor( loader ) {
        // The file loader instance to use during the upload.
        this.loader = loader;
    }

    // Starts the upload process.
    upload() {
        return this.loader.file
            .then( file => new Promise( ( resolve, reject ) => {
                this._initRequest();
                this._initListeners( resolve, reject, file );
                this._sendRequest( file );
            } ) );
    }

    // Aborts the upload process.
    abort() {
        if ( this.xhr ) {
            this.xhr.abort();
        }
    }

    // Initializes the XMLHttpRequest object using the URL passed to the constructor.
    _initRequest() {
        const xhr = this.xhr = new XMLHttpRequest();

        xhr.open( 'POST', '/cke/image', true );
        xhr.responseType = 'json';

        // The route requires a logged-in user and a CSRF token. The XSRF-TOKEN cookie is refreshed on
        // every response, unlike the meta tag, which goes stale after a login/logout without page reload.
        const xsrf = document.cookie.split( '; ' ).find( row => row.startsWith( 'XSRF-TOKEN=' ) );
        const csrf = document.querySelector( 'meta[name="csrf-token"]' );
        if ( xsrf ) {
            xhr.setRequestHeader( 'X-XSRF-TOKEN', decodeURIComponent( xsrf.split( '=' )[ 1 ] ) );
        } else if ( csrf ) {
            xhr.setRequestHeader( 'X-CSRF-TOKEN', csrf.getAttribute( 'content' ) );
        }
        xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
        xhr.setRequestHeader( 'Accept', 'application/json' );
    }

    // Initializes XMLHttpRequest listeners.
    _initListeners( resolve, reject, file ) {
        const xhr = this.xhr;
        const loader = this.loader;
        const genericErrorText = `Couldn't upload file: ${ file.name }.`;

        xhr.addEventListener( 'error', () => reject( genericErrorText ) );
        xhr.addEventListener( 'abort', () => reject() );
        xhr.addEventListener( 'load', () => {
            const response = xhr.response;

            if ( xhr.status === 401 || xhr.status === 419 ) {
                return reject( 'Connectez-vous pour ajouter une image.' );
            }

            if ( xhr.status >= 400 || !response || response.error || !response.url ) {
                const message = response && response.errors && response.errors.upload
                    ? response.errors.upload[ 0 ]
                    : ( response && response.error ? response.error.message : genericErrorText );
                return reject( message );
            }

            resolve( {
                default: response.url
            } );
        } );

        if ( xhr.upload ) {
            xhr.upload.addEventListener( 'progress', evt => {
                if ( evt.lengthComputable ) {
                    loader.uploadTotal = evt.total;
                    loader.uploaded = evt.loaded;
                }
            } );
        }
    }

    // Prepares the data and sends the request.
    _sendRequest( file ) {
        // Prepare the form data.
        const data = new FormData();

        data.append( 'upload', file );

        // Send the request.
        this.xhr.send( data );
    }
}

</script>
